<div [innerHTML]="translationService.getTranslation('contact_send')"></div>

<div class="mt-3 float-end">
  <button *ngIf="showBackToOverviewButton"
          mat-raised-button color="primary" (click)="backToOverview()" [innerHTML]="translationService.getTranslation('button_back_to_overview')">
  </button>
</div>
